/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AnalysisResultDtoAirPressure } from './AnalysisResultDtoAirPressure';
import {
    AnalysisResultDtoAirPressureFromJSON,
    AnalysisResultDtoAirPressureFromJSONTyped,
    AnalysisResultDtoAirPressureToJSON,
} from './AnalysisResultDtoAirPressure';
import type { AnalysisResultDtoAirPressureFault } from './AnalysisResultDtoAirPressureFault';
import {
    AnalysisResultDtoAirPressureFaultFromJSON,
    AnalysisResultDtoAirPressureFaultFromJSONTyped,
    AnalysisResultDtoAirPressureFaultToJSON,
} from './AnalysisResultDtoAirPressureFault';
import type { AnalysisResultDtoAreaFlatness } from './AnalysisResultDtoAreaFlatness';
import {
    AnalysisResultDtoAreaFlatnessFromJSON,
    AnalysisResultDtoAreaFlatnessFromJSONTyped,
    AnalysisResultDtoAreaFlatnessToJSON,
} from './AnalysisResultDtoAreaFlatness';
import type { AnalysisResultDtoBeamDoseOutput } from './AnalysisResultDtoBeamDoseOutput';
import {
    AnalysisResultDtoBeamDoseOutputFromJSON,
    AnalysisResultDtoBeamDoseOutputFromJSONTyped,
    AnalysisResultDtoBeamDoseOutputToJSON,
} from './AnalysisResultDtoBeamDoseOutput';
import type { AnalysisResultDtoBeamQualityFactor } from './AnalysisResultDtoBeamQualityFactor';
import {
    AnalysisResultDtoBeamQualityFactorFromJSON,
    AnalysisResultDtoBeamQualityFactorFromJSONTyped,
    AnalysisResultDtoBeamQualityFactorToJSON,
} from './AnalysisResultDtoBeamQualityFactor';
import type { AnalysisResultDtoMeanAirTemperature } from './AnalysisResultDtoMeanAirTemperature';
import {
    AnalysisResultDtoMeanAirTemperatureFromJSON,
    AnalysisResultDtoMeanAirTemperatureFromJSONTyped,
    AnalysisResultDtoMeanAirTemperatureToJSON,
} from './AnalysisResultDtoMeanAirTemperature';
import type { AnalysisResultDtoXProfile } from './AnalysisResultDtoXProfile';
import {
    AnalysisResultDtoXProfileFromJSON,
    AnalysisResultDtoXProfileFromJSONTyped,
    AnalysisResultDtoXProfileToJSON,
} from './AnalysisResultDtoXProfile';
import type { EvaluationScopeCategory } from './EvaluationScopeCategory';
import {
    EvaluationScopeCategoryFromJSON,
    EvaluationScopeCategoryFromJSONTyped,
    EvaluationScopeCategoryToJSON,
} from './EvaluationScopeCategory';

/**
 * 
 * @export
 * @interface AnalysisResultDto
 */
export interface AnalysisResultDto {
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResultDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResultDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnalysisResultDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResultDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    creatorUser?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    lastModifierUser?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    measurementId?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    zeroMeasurementId?: string;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    calibrationCertificateNumber?: string | null;
    /**
     * 
     * @type {EvaluationScopeCategory}
     * @memberof AnalysisResultDto
     */
    evaluationScopeCategory?: EvaluationScopeCategory;
    /**
     * 
     * @type {AnalysisResultDtoAirPressure}
     * @memberof AnalysisResultDto
     */
    airPressure?: AnalysisResultDtoAirPressure | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultDto
     */
    airPressureFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoMeanAirTemperature}
     * @memberof AnalysisResultDto
     */
    meanAirTemperature?: AnalysisResultDtoMeanAirTemperature | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultDto
     */
    meanAirTemperatureFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoAreaFlatness}
     * @memberof AnalysisResultDto
     */
    areaFlatness?: AnalysisResultDtoAreaFlatness | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultDto
     */
    areaFlatnessFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoBeamDoseOutput}
     * @memberof AnalysisResultDto
     */
    beamDoseOutput?: AnalysisResultDtoBeamDoseOutput | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultDto
     */
    beamDoseOutputFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoAreaFlatness}
     * @memberof AnalysisResultDto
     */
    beamProfileConstancy?: AnalysisResultDtoAreaFlatness | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultDto
     */
    beamProfileConstancyFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoBeamQualityFactor}
     * @memberof AnalysisResultDto
     */
    beamQualityFactor?: AnalysisResultDtoBeamQualityFactor | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof AnalysisResultDto
     */
    beamQualityFactorFault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {AnalysisResultDtoXProfile}
     * @memberof AnalysisResultDto
     */
    xProfile?: AnalysisResultDtoXProfile | null;
    /**
     * 
     * @type {AnalysisResultDtoXProfile}
     * @memberof AnalysisResultDto
     */
    yProfile?: AnalysisResultDtoXProfile | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultDto
     */
    $type?: AnalysisResultDtoTypeEnum;
}


/**
 * @export
 */
export const AnalysisResultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAnalysisComponentDtoAnalysisResultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.AnalysisComponent.Dto.AnalysisResultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type AnalysisResultDtoTypeEnum = typeof AnalysisResultDtoTypeEnum[keyof typeof AnalysisResultDtoTypeEnum];


/**
 * Check if a given object implements the AnalysisResultDto interface.
 */
export function instanceOfAnalysisResultDto(value?: unknown): value is AnalysisResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(AnalysisResultDtoTypeEnum)[0];
}

export function AnalysisResultDtoFromJSON(json: any): AnalysisResultDto {
    return AnalysisResultDtoFromJSONTyped(json, false);
}

export function AnalysisResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'creatorUser': !exists(json, 'creatorUser') ? undefined : json['creatorUser'],
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : json['lastModifierUser'],
        'measurementId': !exists(json, 'measurementId') ? undefined : json['measurementId'],
        'zeroMeasurementId': !exists(json, 'zeroMeasurementId') ? undefined : json['zeroMeasurementId'],
        'calibrationCertificateNumber': !exists(json, 'calibrationCertificateNumber') ? undefined : json['calibrationCertificateNumber'],
        'evaluationScopeCategory': !exists(json, 'evaluationScopeCategory') ? undefined : EvaluationScopeCategoryFromJSON(json['evaluationScopeCategory']),
        'airPressure': !exists(json, 'airPressure') ? undefined : AnalysisResultDtoAirPressureFromJSON(json['airPressure']),
        'airPressureFault': !exists(json, 'airPressureFault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['airPressureFault']),
        'meanAirTemperature': !exists(json, 'meanAirTemperature') ? undefined : AnalysisResultDtoMeanAirTemperatureFromJSON(json['meanAirTemperature']),
        'meanAirTemperatureFault': !exists(json, 'meanAirTemperatureFault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['meanAirTemperatureFault']),
        'areaFlatness': !exists(json, 'areaFlatness') ? undefined : AnalysisResultDtoAreaFlatnessFromJSON(json['areaFlatness']),
        'areaFlatnessFault': !exists(json, 'areaFlatnessFault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['areaFlatnessFault']),
        'beamDoseOutput': !exists(json, 'beamDoseOutput') ? undefined : AnalysisResultDtoBeamDoseOutputFromJSON(json['beamDoseOutput']),
        'beamDoseOutputFault': !exists(json, 'beamDoseOutputFault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['beamDoseOutputFault']),
        'beamProfileConstancy': !exists(json, 'beamProfileConstancy') ? undefined : AnalysisResultDtoAreaFlatnessFromJSON(json['beamProfileConstancy']),
        'beamProfileConstancyFault': !exists(json, 'beamProfileConstancyFault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['beamProfileConstancyFault']),
        'beamQualityFactor': !exists(json, 'beamQualityFactor') ? undefined : AnalysisResultDtoBeamQualityFactorFromJSON(json['beamQualityFactor']),
        'beamQualityFactorFault': !exists(json, 'beamQualityFactorFault') ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['beamQualityFactorFault']),
        'xProfile': !exists(json, 'xProfile') ? undefined : AnalysisResultDtoXProfileFromJSON(json['xProfile']),
        'yProfile': !exists(json, 'yProfile') ? undefined : AnalysisResultDtoXProfileFromJSON(json['yProfile']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function AnalysisResultDtoToJSON(value?: AnalysisResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'creatorUser': value.creatorUser,
        'lastModifierUser': value.lastModifierUser,
        'measurementId': value.measurementId,
        'zeroMeasurementId': value.zeroMeasurementId,
        'calibrationCertificateNumber': value.calibrationCertificateNumber,
        'evaluationScopeCategory': EvaluationScopeCategoryToJSON(value.evaluationScopeCategory),
        'airPressure': AnalysisResultDtoAirPressureToJSON(value.airPressure),
        'airPressureFault': AnalysisResultDtoAirPressureFaultToJSON(value.airPressureFault),
        'meanAirTemperature': AnalysisResultDtoMeanAirTemperatureToJSON(value.meanAirTemperature),
        'meanAirTemperatureFault': AnalysisResultDtoAirPressureFaultToJSON(value.meanAirTemperatureFault),
        'areaFlatness': AnalysisResultDtoAreaFlatnessToJSON(value.areaFlatness),
        'areaFlatnessFault': AnalysisResultDtoAirPressureFaultToJSON(value.areaFlatnessFault),
        'beamDoseOutput': AnalysisResultDtoBeamDoseOutputToJSON(value.beamDoseOutput),
        'beamDoseOutputFault': AnalysisResultDtoAirPressureFaultToJSON(value.beamDoseOutputFault),
        'beamProfileConstancy': AnalysisResultDtoAreaFlatnessToJSON(value.beamProfileConstancy),
        'beamProfileConstancyFault': AnalysisResultDtoAirPressureFaultToJSON(value.beamProfileConstancyFault),
        'beamQualityFactor': AnalysisResultDtoBeamQualityFactorToJSON(value.beamQualityFactor),
        'beamQualityFactorFault': AnalysisResultDtoAirPressureFaultToJSON(value.beamQualityFactorFault),
        'xProfile': AnalysisResultDtoXProfileToJSON(value.xProfile),
        'yProfile': AnalysisResultDtoXProfileToJSON(value.yProfile),
        '$type': value.$type,
    });
}

